export default {
    data() {
        return {
            originList: [
                'Musicstack',
                'Void',
            ]
        }
    }
}